import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('Oasis.SubscriptionPlan');
    const [active, setActive] = useState(0);
    const { locale = 'eu' } = useRouter();

    const imgData: {
        [key: string]: any;
    } = {
        eu: {
            pc: [
                'https://websiteoss.ecoflow.com/figma-uploads/1779939064277-421igv-compressed-EU/1920/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281147221/Frame%201612690173.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1779933001118-z37jh2-compressed-EU/1920/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/figma-uploads/1779939095831-pjwgt5-compressed-EU/768/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281218801/Frame%201612707408.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1779933041271-gz008y-compressed-EU/768/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/figma-uploads/1779939112917-mq7uj8-compressed-EU/375/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281278028/Frame%201612707409.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1779933100374-v3gq3a-compressed-EU/375/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225915706/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_EN.pdf',
        },
        nl: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1756783046456/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281147221/Frame%201612690173.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756783046599/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1756783108847/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281218801/Frame%201612707408.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756783109047/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1756783135909/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281278028/Frame%201612707409.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756783136085/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225915706/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_EN.pdf',
        },
        uk: {
            pc: [
                'https://websiteoss.ecoflow.com/figma-uploads/1779939064277-421igv-compressed-EU/1920/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281335072/Frame%201612707385.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1779933001118-z37jh2-compressed-EU/1920/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/figma-uploads/1779939095831-pjwgt5-compressed-EU/768/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281390792/Frame%201612707388.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1779933041271-gz008y-compressed-EU/768/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/figma-uploads/1779939112917-mq7uj8-compressed-EU/375/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281436476/Frame%201612707391.jpg',
                'https://websiteoss.ecoflow.com/figma-uploads/1779933100374-v3gq3a-compressed-EU/375/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225915706/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_EN.pdf',
        },
        fr: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1756783196293/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281492662/Frame%201612707415.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756783196512/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1756783217513/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281531138/Frame%201612707418.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756783217661/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1756783237733/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281570179/Frame%201612707421.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756783237942/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225959313/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_FR.pdf',
        },
        de: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1756794578794/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281620232/Frame%201612707397.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756794619321/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1756794655370/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281680071/Frame%201612707400.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756794655630/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1756794694002/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281714579/Frame%201612707410.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756794694308/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225915580/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_DE.pdf',
        },
        es: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1756782590161/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281790624/Frame%201612707443.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756782590312/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1756782936402/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281827300/Frame%201612707446.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756782936296/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1756782998858/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281860750/Frame%201612707449.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756782999032/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225959123/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_ES.pdf',
        },
        it: {
            pc: [
                'https://websiteoss.ecoflow.com/upload/image/1756783270083/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281891755/Frame%201612707427.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756783270287/03.jpg',
            ],
            pad: [
                'https://websiteoss.ecoflow.com/upload/image/1756783289339/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747281928142/Frame%201612707441.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756783289485/03.jpg',
            ],
            h5: [
                'https://websiteoss.ecoflow.com/upload/image/1756783312312/01.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1747282023816/Frame%201612707440.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1756783312519/03.jpg',
            ],
            link: 'https://websiteoss.ecoflow.com/upload/pdf/1747225915913/OASIS%E9%A1%B5%E9%9D%A2BKW%E5%8A%9F%E8%83%BD%E5%88%97%E8%A1%A8_IT.pdf',
        },
    };

    return (
        <div className={`${styles.SubscriptionPlan} eco-content`}>
            <EfSpec />
            <div className="title">{t('title')}</div>
            {/* <EcoSpaceSmall /> */}
            <div className="box">
                <div className="img1">
                    <EfImg className="listA-card-img" pc={imgData[locale].pc[0]} pad={imgData[locale].pad[0]} h5={imgData[locale].h5[0]} />
                </div>
                <div className="img2">
                    <EfImg className="listA-card-img" pc={imgData[locale].pc[1]} pad={imgData[locale].pad[1]} h5={imgData[locale].h5[1]} />
                </div>
                <div className="img3">
                    <EfImg className="listA-card-img" pc={imgData[locale].pc[2]} pad={imgData[locale].pad[2]} h5={imgData[locale].h5[2]} />
                </div>
                <div className="box-desc">
                    {t('desc1')}
                    <br></br>
                    <br></br>
                    {t('desc2')}
                </div>
                {/* <div className="box-link"></div> */}
                <a className="box-link" href={imgData[locale].link} target="_blank" rel="noreferrer">
                    {t('link')}
                </a>
            </div>
        </div>
    );
}
